export function ProductImagePlaceholder({
  className = "",
}: {
  className?: string;
}) {
  return (
    <div
      className={`absolute inset-0 flex items-center justify-center bg-[#0D0D0D] ${className}`.trim()}
      aria-hidden
    >
      <div className="flex w-2/3 flex-col gap-3">
        {["#E84040", "#3B7FE8", "#E8C547", "#40C070"].map((color, index) => (
          <span
            key={color}
            className="block rounded-full"
            style={{
              height: `${2 + index}px`,
              backgroundColor: color,
              boxShadow: `0 0 10px ${color}55`,
              opacity: 0.9 - index * 0.12,
            }}
          />
        ))}
      </div>
    </div>
  );
}
